<template>
  <div>
    <Navbar />
    <Breadcrumb />
    <b-card class="mx-auto col-lg-10 col-md-12 col-sm-12 border-0">
      <b-card-title class="mb-4 pb-4">
        <div class="row">
          <span class="survey-type-badge btn-primary mr-2">
            <fa-icon
              name="file-medical-alt"
              size="6x"
            />
          </span>
          <span>
            Test
          </span>
        </div>
      </b-card-title>
      <div
        class="mx-auto col-9"
      >
        <h4>Test Nets Payment</h4>
        <b-form-group>
          <b-button
            @click="resetpaymentid"
          >
            Reset payment ID
          </b-button>
          {{ netspayment_id }}
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="order_id"
            placeholder="Order ID"
          />
        </b-form-group>
        <b-form-group label="I want to pay by;">
          <b-form-radio-group stacked>
            <b-form-radio
              v-model="payment"
              name="payment"
              value="4"
            >
              Nets Credit Card - DEV ONLY
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <!-- NETS Easy Payment -->
        <div v-if="payment == 4">
          <NetsPayment
            product-name="GDQ Report"
            :dibs-amount="100"
            :order-id="order_id"
            :accept-url="web_url"
            :cancel-url="web_url"
          />
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import Navbar from './Navbar'
import Breadcrumb from './Breadcrumb'
import NetsPayment from './NetsPayment'
import { config } from '../../config'

export default {
  name: 'Test',
  components: {
    Navbar,
    Breadcrumb,
    NetsPayment
  },
  data () {
    return {
      order_id: 0,
      payment: null,
      netspayment_id: this.$route.query.paymentid ? this.$route.query.paymentid : '',
      nets_paid_amount: 0,
      nets_invoice_amount: 0,
      base_url: config.base_url,
      web_url: window.location + ''
    }
  },
  computed: {
    gdq_url: function () {
      var url = window.location
      return url
    }
  },
  created () {
    this.checknetspayment()
  },
  methods: {
    resetpaymentid () {
      this.$store.dispatch('netspayment_set', { current_netspayment_id: '' })
    },
    checknetspayment () {
      if (this.netspayment_id != '') {
        // Update the invoice and payment_lof
        this.$store.dispatch('netspayment_update', { paymentId: this.netspayment_id })
          .then((resp) => {
            if (resp.data.status == 'OK') {
              console.log(resp.data)
            } else {
              alert(resp.data.error)
            }
          })
      }
    }
  }
}
</script>
<style scoped></style>
<style>
.hidden_header {
  display: none;
}
</style>
